import { render, staticRenderFns } from "./org-add-or-update.vue?vue&type=template&id=6c8a3f15&lang=pug"
import script from "./org-add-or-update.vue?vue&type=script&lang=js"
export * from "./org-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports